export default {
      id: "capital-usage",
      viewBox: "0 0 26 32",
      url: __webpack_public_path__ + "sprite.svg#capital",
      toString: function () {
        return this.url;
      }
    }